import React, { useEffect, useState } from "react";
import { useUserSettings } from "./CurrentUserContext";

 const ProfileContext = React.createContext();

 const ProfileProvider = ({ children }) =>{

  //const {currentUser} = useUserSettings();
  
  const _principalProfile = undefined//currentUser.perfilPrincipal.value;

  //const StorageProfile = localStorage.getItem("perfil-partes");
  //const WrongProfile = (StorageProfile===null || typeof StorageProfile !== 'string' || StorageProfile === 'undefined' || Array.isArray(StorageProfile) || StorageProfile === '[object Object]');

   let [profile, setProfile] = useState(_principalProfile)//useState(WrongProfile === true ? 'USR': StorageProfile);

  //useEffect(()=>{if(currentUser!==undefined && Object.keys(currentUser).length>0){setProfile(currentUser.perfilPrincipal.value)}},[currentUser])
 
  //useEffect(()=>{profile && localStorage.setItem("perfil-partes",profile);},[profile])

  return (
    <ProfileContext.Provider
      value={{
        currentProfile: profile,
        setCurrentProfile: (newProfile) => setProfile(newProfile),
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
}

const useProfileApp = () => {
  const context = React.useContext(ProfileContext);

  if (!context) {
    throw new Error(`ProfileContext debe ser usado dentro de ProfileProvider`);
  }

  return context;
}

export { ProfileProvider, useProfileApp };